'use strict';

var formChartCtrl = ['Department', '$stateParams', function(Department, $stateParams) {
    var _this = this;
    function parseData(items) {
        var data = {
            labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
            series: []
        };

        var dayMil = 1000 * 60 * 60 * 24;
        var today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);

        data.labels.forEach(function(label, index) {
            var dayLimitStart = new Date(today.getTime() - (dayMil * (30 - index)));
            var dayLimitEnd = new Date(today.getTime() - (dayMil * (30 - (index + 1))));

            data.series[index] = items.filter(function(item) {
                item._createdAt = new Date(item._createdAt);
                return item._createdAt >= dayLimitStart && item._createdAt <= dayLimitEnd;
            });
        });

        data.series = data.series.map(function(items) {
            return items.length;
        });
        data.series = [data.series];

        return data;
    }

    _this.barData = parseData(this.items || []);

    this.barOptions = {
        showArea: false,
        showPoint: true,
        fullWidth: false,
        showLine: true,
        lineSmooth: true,
        axisX: {
            // We can disable the grid for this axis
            showGrid: false,
            showLabel: false,
            offset: 0
        },
        axisY: {
            showGrid: false,
            offset: 50
        }
    };

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            items: '='
        },
        controller: formChartCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-form/chartDirective.html'
    };
};
